import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import RightSidebar from 'Views/Page/Content/RightSidebar';
import { useRightSidebarContext } from 'Views/Page/Content/RightSidebar/RightSidebarContext';

const Container = ({ relationship, onPickNewSize, setSaving }) => {
  const { loadRightSidebarCollectionLink } = useRightSidebarContext();

  useEffect(() => {
    if (!relationship) {
      return;
    }

    // This will load the collection of levers for the roadmap explorer page
    // into the right sidebar.
    // see: webapp/src/Views/Page/Content/RightSidebar/Content/Templates/RoadmapExplorerLevers
    loadRightSidebarCollectionLink(relationship.link('related'));
  }, [relationship]);

  return (
    <RightSidebar
      componentProps={{
        hideHeader: true,
        onPickNewSize,
        setSaving,
        alwaysShowDivider: true,
      }}
    />
  );
};

Container.propTypes = {
  relationship: PropTypes.object.isRequired,
  onPickNewSize: PropTypes.func.isRequired,
  setSaving: PropTypes.func.isRequired,
};

Container.defaultProps = {};

export default Container;
